import type { Logger } from '@vp/ubik-logging'

import type { Project } from '../types/Project'
import { navigateToNextStep } from '../hooks/useAddToCartAction/navigation'

/**
 * Navigates to the teams page from the quantity selection page.
 * This handles the redirect for products with groups & teams data or placeholders.
 *
 * Since YSD studio doesn't check for the existence of placeholders in the design
 * before navigating to the next step, customers always land on QSP. This function
 * redirects them to the Groups & Teams page when appropriate.
 *
 * @param primaryProject - The project to redirect with
 */
export function navigateToTeamsPage(primaryProject: Project, logger: Logger): void {
  const currentUrl = new URL(window.location.href)

  // Fallback to '/team/' for local development where '/quantity' isn't in the path
  const teamPath = currentUrl.pathname.includes('/quantity') ? currentUrl.pathname.replace('/quantity', '/team') : '/team/'

  // Build the full URL with same origin, preserving query params
  const teamUrl = `${currentUrl.origin}${teamPath}${currentUrl.search}`

  navigateToNextStep([primaryProject], teamUrl, logger)
}
